
export default {
  isPoneAvailable:function($poneInput,vueObj){
    var myreg = /^[1][0-9]{10}$/;
    if($poneInput.val()==''){
      $(".tel_error").text("手机号不能为空");
      return false;
    }else if (!myreg.test($poneInput.val())) {
      $(".tel_error").text("请输入正确的手机号");
      return false;
    }
    else {
      $(".tel_error").text("");
      var routeData=vueObj.$router.resolve({name:"appointConsultation",query:{tel:vueObj.tel}})
      // var routeData=vueObj.$router.resolve({name:"appointConsultation",params:{tel:vueObj.tel}})
      window.open(routeData.href,'_blank')
      // vueObj.$router.push({path:'/home/appointConsultation'});
      return true;
    }
  },
  isPoneAvailableNew: function($poneInput,vueObj){
    var myreg = /^[1][0-9]{10}$/;
    if($poneInput.val()==''){
      $(".tel_error").text("手机号不能为空");
      return false;
    }else if (!myreg.test($poneInput.val())) {
      $(".tel_error").text("请输入正确的手机号");
      return false;
    }
    else {
      $(".tel_error").text("");
      // var routeData=vueObj.$router.resolve({name:"appointConsultation",query:{tel:vueObj.tel}})
      // // var routeData=vueObj.$router.resolve({name:"appointConsultation",params:{tel:vueObj.tel}})
      // window.open(routeData.href,'_blank')
      // vueObj.$router.push({path:'/home/appointConsultation'});
      return true;
    }
  },
}



// WEBPACK FOOTER //
// ./src/lib/common.js